import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { transformViewDate } from "utils/date-utils";
import { DATE_TIME_FORMAT } from "../../helpers";
import useStyles from "./styles";

interface IProps {
  videos: racehorse360.ITrackOpticsVideo[];
  selectedVideoId: string;
  onChangeSelectedVideo: (value: racehorse360.ITrackOpticsVideo) => void;
}

const VideoList = (props: IProps) => {
  const { videos, selectedVideoId, onChangeSelectedVideo } = props;

  const classes = useStyles();

  const handleClickVideoItem = (video: racehorse360.ITrackOpticsVideo) => {
    onChangeSelectedVideo(video);
  };

  const workoutsVideos = videos.map(video => (
    <ListItem
      key={video.id}
      button
      disableRipple
      classes={{
        root: classes.listItemRoot
      }}
      selected={video.id === selectedVideoId}
      onClick={() => handleClickVideoItem(video)}
    >
      <div className={classes.listItemRootRow}>{video.videoId}</div>
      <div className={classes.listItemRootRow}>{video.facility.name}</div>
      <div className={classes.listItemRootRow}>
        {transformViewDate(video.date, null, DATE_TIME_FORMAT)}
      </div>
    </ListItem>
  ));

  return (
    <div className={classes.videoListWrap}>
      <List classes={{ root: classes.listRoot }}>{workoutsVideos}</List>
    </div>
  );
};

export default React.memo(VideoList);
